import { DefaultDirections, SortProviderProps, UrlSortProvider } from '@tableau/data-catalog-shared';
import * as React from 'react';

import { MetricOrderField, OrderDirection } from '../../../../gen-src/queries/globalTypes';

export type MetricsValidSortFields = MetricOrderField.NAME;

export const MetricsDefaultDirections: DefaultDirections<MetricsValidSortFields> = {
  [MetricOrderField.NAME]: OrderDirection.ASC,
};

export const MetricsDefaultSortField = MetricOrderField.NAME;

export function MetricsGridSortProvider(
  props: Pick<SortProviderProps<MetricsValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<MetricsValidSortFields>
      validOrderFieldsWithDefaultDirections={MetricsDefaultDirections}
      defaultField={MetricsDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
